import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGIN_REQUEST, LOGOUT } from 'Components/reduxType/login/index';
import { getUser } from 'Components/_helpers/localstorage';

const initialState = {
  isAuthenticated: getUser()? true: false,
  isAuthenticating: false,
  error: '',
  user: getUser(),
};

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticating: true
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticating: false,
        isAuthenticated: true,
        user: action.payload,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isAuthenticating: false,
        error: action.payload,
        user: null,
      };
    case LOGOUT:
      return {};
    default:
      return state
  }
}